<template>
  <div>
    <v-layout row wrap v-if="hideExternal == false">
      <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 20px">
        <v-img
          v-if="DataUrlExternalView != null"
          :src="DataUrlExternalView"
          contain
        ></v-img>
      </v-flex>
      <v-flex xs12 sm12 md6 lg6 xl6 style="padding: 20px">
        <v-btn block @click="fSelectDialog = true" outlined color="purple">{{
          BtnTitle
        }}</v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="hideExternal">
      <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 20px">
        <v-btn block @click="fSelectDialog = true" outlined color="purple">{{
          BtnTitle
        }}</v-btn>
      </v-flex>
    </v-layout>
    <template>
      <v-dialog max-width="600" persistent v-model="fSelectDialog">
        <v-card>
          <v-card-title>
            <span style="font-size: 15px">انتخاب {{ BtnTitle }}</span>
            <v-spacer></v-spacer>
            <v-btn @click="CloseDialog" color="red" icon
              ><v-icon>fa fa-times</v-icon></v-btn
            >
            <div style="width: 100%">
              <v-divider></v-divider>
            </div>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex x12 sm12 md7 lg7 xl7 style="padding: 20px">
                <v-chip small color="green accent-1">{{ FileName }}</v-chip>
              </v-flex>
              <v-flex x12 sm12 md5 lg5 xl5 style="padding: 20px">
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 20px">
                    <v-row>
                      <v-col cols="1"
                        ><input
                          @change="fileSelected"
                          type="file"
                          style="display: none"
                          ref="FileSelect"
                          accept="application/pdf"
                      /></v-col>
                      <v-col cols="11"
                        ><v-btn
                          @click="$refs.FileSelect.click()"
                          outlined
                          color="purple"
                          dark
                          >انتخاب فایل</v-btn
                        ></v-col
                      >
                    </v-row>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding: 20px">
                <v-btn
                  @click="UploadFile"
                  block
                  color="green"
                  v-if="File != null"
                  outlined
                  dark
                  ><v-icon small style="padding-left: 5px">fa fa-upload</v-icon
                  >آپلود</v-btn
                >
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <div class="vld-parent">
        <loading
          color="#f75314"
          :width="parseInt(45)"
          :height="parseInt(45)"
          background-color="#fff"
          :active.sync="isLoading"
          :is-full-page="true"
        ></loading>
      </div>
    </template>
  </div>
</template>
<style scoped>
</style>
<script>
const axios = require("axios");
const ApiUrl = require("../constant/apiurl");
const MSGHNDL = require("../constant/MessageHandler");
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  props: {
    BtnTitle: { type: String },
    OldFile: { type: String },
    hideExternal: { type: Boolean, default: false },
  },
  name: "NonImgUploader",
  components: {
    Loading,
  },
  data: () => ({
    fSelectDialog: false,
    DataUrl: null,
    DataUrlExternalView: null,
    FileName: "",
    isLoading: false,
    File: null,
  }),
  created() {
    let vm = this;

    axios.interceptors.request.use(
      (config) => {
        vm.isLoading = true;
        return config;
      },
      (error) => {
        vm.isLoading = false;
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        vm.isLoading = false;
        return response;
      },
      (error) => {
        vm.isLoading = false;
        return Promise.reject(error);
      }
    );
  },
  watch: {
    OldFile: function (nv, ov) {
      let vm = this;
    //   if (nv != null) {
    //     vm.DataUrlExternalView =
    //       ApiUrl.BaseDl + vm.Root + "/" + vm.Folder + "/" + nv;
    //   }
    },
  },
  methods: {
    resetUploader() {
      let vm = this;
      vm.File = null;
      vm.DataUrl = null;
      vm.FileName = null;
      vm.fSelectDialog = false;
    },
    async UploadFile() {
      let vm = this;
      if (vm.File == null) {
        MSGHNDL.ERR("فایل انتخاب نشده است");
        return;
      }
      var data = new FormData();
      data.append("file", vm.File);
      var url = ApiUrl.uploadProductManual;
      await axios
        .post(url, data)
        .then((res) => {
          var r = res.data;
          if (r.status) {
            MSGHNDL.OK(r.msg);
            vm.resetUploader();
            vm.$emit("RetunedFileName", r.data);
          } else {
            MSGHNDL.ERR(r.msg);
          }
        })
        .catch((err) => {
          MSGHNDL.ERR(err);
        });
    },
    fileSelected(e) {
      let vm = this;
      var file = e.target.files[0];
      vm.FileName = file.name;
      vm.File = file;
    },
    CloseDialog() {
      this.fSelectDialog = false;
    },
  },
};
</script>
